import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-81014f0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BOX" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-ct content\" data-v-81014f0e><div class=\"info-box\" data-v-81014f0e><div data-v-81014f0e><div class=\"title\" data-v-81014f0e>Department Address</div><div data-v-81014f0e> Ward 81, 12th Floor, Building 8, West Campus, Zhongshan Hospital Affiliated to Fudan University </div></div><div data-v-81014f0e><div class=\"title\" data-v-81014f0e>Kidney transplant general clinic address</div><div data-v-81014f0e> Clinic Room 129, Area 1, 2F, Building 20, West Campus, Zhongshan Hospital Affiliated to Fudan University (Waiting Area 1, 2F) </div></div><div data-v-81014f0e><div class=\"title\" data-v-81014f0e>Telephone</div><div data-v-81014f0e>021-64041990</div></div><div data-v-81014f0e><div class=\"title\" data-v-81014f0e>Clinic Hours</div><div data-v-81014f0e> Monday afternoon, Tuesday afternoon, Wednesday afternoon, Thursday afternoon, Friday afternoon (except holidays) </div></div></div><div class=\"map-box\" data-v-81014f0e><div id=\"map\" class=\"map\" data-v-81014f0e></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

import { onMounted, ref } from "vue";
import AMapLoader from "@amap/amap-jsapi-loader";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const map = ref<any>(null);
onMounted(async () => {
  AMapLoader.load({
    key: "98da2fba2ef1027023a833f2fbec7af7",
    version: "1.4.15", // 指定要加载的 JSAPI 的版本
  }).then((AMap) => {
    map.value = new AMap.Map("map", {
      center: [121.453476, 31.199004], // 中心点经纬度
      zoom: 16, // 缩放级别
      viewMode: "2D", //设置地图模式
      lang: "en",
    });

    //创建点标记
    new AMap.Marker({
      map: map.value,
      position: [121.453476, 31.199004],
    });
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})